import image from '../../../assets/AdobeStock_304369278.png';

export const articles = [
    {
        title: "Czynnościowe zaburzenia jelit",
        author: "Dr n.med. Grzegorz Kowalski",
        description:
            "Czynnościowe choroby jelit to przewlekłe zaburzenia przewodu pokarmowego, które w znaczny sposób mogą wpływać na jakość życia chorego. Ze względu na mnogość potencjalnych przyczyn, zaburzenia nastręczają lekarzom trudności diagnostycznych, a właściwe rozpoznanie bywa prawie niemożliwe.",
        image: image,
        button: "POBIERZ PDF"
    },
    {
        title: "Czynnościowe zaburzenia jelit dwa",
        author: "Dr n.med. Jadwiga Bąbel",
        description:
            "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.",
        image: image,
        button: "CZYTAJ"
    },
    {
        title: "Czynnościowe zaburzenia jelit trzy",
        author: "Dr n.med. Tomasz Broncer",
        description:
            "Czynnościowe choroby jelit to przewlekłe zaburzenia przewodu pokarmowego, które w znaczny sposób mogą wpływać na jakość życia chorego. Ze względu na mnogość potencjalnych przyczyn, zaburzenia nastręczają lekarzom trudności diagnostycznych, a właściwe rozpoznanie bywa prawie niemożliwe.",
        image: image,
        button: "OGLĄDAJ"
    },
    {
        title: "Czynnościowe zaburzenia jelit cztery",
        author: "Dr n.med. Andrzej Kowalski",
        description:
            "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.",
        image: image,
        button: "POSŁUCHAJ"
    },
];